import {Preview} from "../components";
import {useDispatch, useSelector} from "react-redux";
import {AdvancedConfigurationForm} from "../forms";
import * as mainSlice from "../store/mainSlice";


export default function ViewScreen(props) {
  const dispatch = useDispatch()
  const store = useSelector(({main}) => ({
    dimensions: main.dimensions,
    config: main.config,
  }))

  const handleSubmit = (data) => {
    dispatch(mainSlice.setConfig(data))
  }

  return (
    <div className="container-fluid">


      <div className="view__container">
        <div>
          <Preview
              dimensions={store.dimensions}
              config={store.config}
          />
        </div>
        <div>
          <AdvancedConfigurationForm
            dimensions={store.dimensions}
            config={store.config}
            onSubmit={handleSubmit}
          />
        </div>
      </div>


    </div>
  )
}
